var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { ATNDeserializer } from "antlr4ts/atn/ATNDeserializer";
import { Lexer } from "antlr4ts/Lexer";
import { LexerATNSimulator } from "antlr4ts/atn/LexerATNSimulator";
import { VocabularyImpl } from "antlr4ts/VocabularyImpl";
import * as Utils from "antlr4ts/misc/Utils";
const _FilterExpressionLexer = class _FilterExpressionLexer extends Lexer {
  // @Override
  // @NotNull
  get vocabulary() {
    return _FilterExpressionLexer.VOCABULARY;
  }
  // tslint:enable:no-trailing-whitespace
  constructor(input) {
    super(input);
    this._interp = new LexerATNSimulator(_FilterExpressionLexer._ATN, this);
  }
  // @Override
  get grammarFileName() {
    return "FilterExpression.g4";
  }
  // @Override
  get ruleNames() {
    return _FilterExpressionLexer.ruleNames;
  }
  // @Override
  // @ts-ignore ts 4.x
  get serializedATN() {
    return _FilterExpressionLexer._serializedATN;
  }
  // @Override
  get channelNames() {
    return _FilterExpressionLexer.channelNames;
  }
  // @Override
  get modeNames() {
    return _FilterExpressionLexer.modeNames;
  }
  static get _ATN() {
    if (!_FilterExpressionLexer.__ATN) {
      _FilterExpressionLexer.__ATN = new ATNDeserializer().deserialize(Utils.toCharArray(_FilterExpressionLexer._serializedATN));
    }
    return _FilterExpressionLexer.__ATN;
  }
};
__publicField(_FilterExpressionLexer, "T__0", 1);
__publicField(_FilterExpressionLexer, "T__1", 2);
__publicField(_FilterExpressionLexer, "T__2", 3);
__publicField(_FilterExpressionLexer, "EQ", 4);
__publicField(_FilterExpressionLexer, "IN", 5);
__publicField(_FilterExpressionLexer, "NOTIN", 6);
__publicField(_FilterExpressionLexer, "NE", 7);
__publicField(_FilterExpressionLexer, "LE", 8);
__publicField(_FilterExpressionLexer, "LT", 9);
__publicField(_FilterExpressionLexer, "GE", 10);
__publicField(_FilterExpressionLexer, "GT", 11);
__publicField(_FilterExpressionLexer, "AND", 12);
__publicField(_FilterExpressionLexer, "OR", 13);
__publicField(_FilterExpressionLexer, "BETWEEN", 14);
__publicField(_FilterExpressionLexer, "BOOL_TRUE", 15);
__publicField(_FilterExpressionLexer, "BOOL_FALSE", 16);
__publicField(_FilterExpressionLexer, "DELIM", 17);
__publicField(_FilterExpressionLexer, "VARIANT", 18);
__publicField(_FilterExpressionLexer, "STRING", 19);
__publicField(_FilterExpressionLexer, "VERSION", 20);
__publicField(_FilterExpressionLexer, "INTEGER", 21);
__publicField(_FilterExpressionLexer, "WHITESPACE", 22);
// tslint:disable:no-trailing-whitespace
__publicField(_FilterExpressionLexer, "channelNames", ["DEFAULT_TOKEN_CHANNEL", "HIDDEN"]);
// tslint:disable:no-trailing-whitespace
__publicField(_FilterExpressionLexer, "modeNames", ["DEFAULT_MODE"]);
__publicField(_FilterExpressionLexer, "ruleNames", [
  "T__0",
  "T__1",
  "T__2",
  "EQ",
  "IN",
  "NOTIN",
  "NE",
  "LE",
  "LT",
  "GE",
  "GT",
  "AND",
  "OR",
  "BETWEEN",
  "BOOL_TRUE",
  "BOOL_FALSE",
  "DELIM",
  "VARIANT",
  "STRING",
  "VERSION",
  "INTEGER",
  "INT",
  "SIGN",
  "WHITESPACE",
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z"
]);
__publicField(_FilterExpressionLexer, "_LITERAL_NAMES", [
  void 0,
  "'('",
  "')'",
  "','",
  "'=='",
  void 0,
  void 0,
  void 0,
  "'<='",
  "'<'",
  "'>='",
  "'>'"
]);
__publicField(_FilterExpressionLexer, "_SYMBOLIC_NAMES", [
  void 0,
  void 0,
  void 0,
  void 0,
  "EQ",
  "IN",
  "NOTIN",
  "NE",
  "LE",
  "LT",
  "GE",
  "GT",
  "AND",
  "OR",
  "BETWEEN",
  "BOOL_TRUE",
  "BOOL_FALSE",
  "DELIM",
  "VARIANT",
  "STRING",
  "VERSION",
  "INTEGER",
  "WHITESPACE"
]);
__publicField(_FilterExpressionLexer, "VOCABULARY", new VocabularyImpl(
  _FilterExpressionLexer._LITERAL_NAMES,
  _FilterExpressionLexer._SYMBOLIC_NAMES,
  []
));
__publicField(_FilterExpressionLexer, "_serializedATN", `줝쪺֍꾺体؇쉁Ĵ\b					\x07	\x07\b	\b			
	
\v	\v\f	\f\r	\r													\x1B	\x1B				 	 !	!"	"#	#$	$%	%&	&'	'(	()	)*	*+	+,	,-	-.	./	/0	01	12	23	3r
\x07\x07x
\x07\x07\x07\x07\x07\x07\x07\b\b\b\b\b
\b			

\v\v\v\f\f\r\r
\r\r\r\r\r\r\r\r
\r
£
º
½
À
\rÁ\x07Å
\fÈ\vÌ
\rÍ\x07Ð
\fÓ\v\x07Ù
\fÜ\vç
ê
\x07ñ
\fô\vö
û
\rü\x1B\x1B  !!""##$$%%&&''(())**++,,--..//001122334\x07	\v\x07\r\b	
\v\f\r\x1B!#%')+-/13579;=?ACEGIKMOQSUWY[]_ace$C\\c|\x07//2;C\\aac|\f\f$$^^$$^^3;2;--//\v\v""CCccDDddEEeeFFffGGggHHhhIIiiJJjjKKkkLLllMMmmNNnnOOooPPppQQqqRRrrSSssTTttUUuuVVvvWWwwXXxxYYyyZZzz[[{{\\\\||ī\x07	\v\r\x1B!#%')+1gi\x07k	m\vq\rw\x1B¢¤¬!±#·%¿'Ô)ß+é-õ/÷1ú3Ā5Ă7Ą9Ć;Ĉ=Ċ?ČAĎCĐEĒGĔIĖKĘMĚOĜQĞSĠUĢWĤYĦ[Ĩ]Ī_ĬaĮcİeĲgh\x07*hij\x07+jkl\x07.l\bmn\x07?no\x07?o
pr\x07/qpqrrsstC"tuM'u\fvx\x07/wvwxxyyzM'z{O({|Y-|}C"}~M'~\x07#\x07?\x07>\x07@\x07>\x07?\x07>\x07@\x07?\x07@\x07/3M'9\x07(\x07(\x07/O(U+£ ¡\x07~¡£\x07~¢¢ £¤¥5\x1B¥¦;¦§Y-§¨_0¨©;©ª;ª«M'«¬­Y-­®U+®¯[.¯°;° ±²=²³3³´I%´µW,µ¶;¶"·¼\x07=¸º\x07¹¸¹ºº»»½\x07\f¼¹¼½½$¾À	¿¾ÀÁÁ¿ÁÂÂÆÃÅ	ÄÃÅÈÆÄÆÇÇÑÈÆÉË\x070ÊÌ	ËÊÌÍÍËÍÎÎÐÏÉÐÓÑÏÑÒÒ&ÓÑÔÚ\x07$ÕÙ
Ö×\x07^×Ù	ØÕØÖÙÜÚØÚÛÛÝÜÚÝÞ\x07$Þ(ßà-àá\x070áâ-âã\x070ãæ-äå\x070åç-æäæçç*èê/éèéêêëëì-ì,íö\x072îò	ïñ	\x07ðïñôòðòóóöôòõíõîö.÷ø	\bø0ùû		úùûüüúüýýþþÿ\bÿ2Āā	
ā4Ăă	\vă6Ąą	\fą8Ćć	\rć:Ĉĉ	ĉ<Ċċ	ċ>Čč	č@Ďď	ďBĐđ	đDĒē	ēFĔĕ	ĕHĖė	ėJĘę	ęLĚě	ěNĜĝ	ĝPĞğ	ğRĠġ	ġTĢģ	\x1BģVĤĥ	ĥXĦħ	ħZĨĩ	ĩ\\Īī	ī^Ĭĭ	 ĭ\`Įį	!įbİı	"ıdĲĳ	#ĳfqw¢¹¼ÁÄÆËÍÑØÚæéòõü\b`);
__publicField(_FilterExpressionLexer, "__ATN");
let FilterExpressionLexer = _FilterExpressionLexer;
export {
  FilterExpressionLexer
};
//# sourceMappingURL=FilterExpressionLexer.js.map
